import { render, staticRenderFns } from "./GuestLayout.vue?vue&type=template&id=4752d3e4"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"
import style0 from "./GuestLayout.vue?vue&type=style&index=0&id=4752d3e4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4752d3e4')) {
      api.createRecord('4752d3e4', component.options)
    } else {
      api.reload('4752d3e4', component.options)
    }
    module.hot.accept("./GuestLayout.vue?vue&type=template&id=4752d3e4", function () {
      api.rerender('4752d3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layout/GuestLayout.vue"
export default component.exports